module.exports = __webpack_public_path__ + "static/img/news_2.b31ff1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/news_2.jpg
// module id = cAMT
// module chunks = 0